import { render, staticRenderFns } from "./InspectionRecordPointList.vue?vue&type=template&id=6b4e0ad4&scoped=true&"
import script from "./InspectionRecordPointList.vue?vue&type=script&lang=js&"
export * from "./InspectionRecordPointList.vue?vue&type=script&lang=js&"
import style0 from "./InspectionRecordPointList.vue?vue&type=style&index=0&id=6b4e0ad4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4e0ad4",
  null
  
)

export default component.exports